import React from "react";
import { connect } from "react-redux";
import { Modal, Form, message } from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicFilter from "../../components/frame/DynamicFilter";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import EmployeeIncentiveLeaveService from "../../services/Approval/employee-incentive-leave-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';
import {fetchEmployeesList} from '../../actions/employee-management-actions';

class EmployeeIncentiveLeave extends ReactAbstract {

   

    initReload = true
    dataMode = 0 
    deleteRowSelection = false
    moduleName = "approval"
    childModuleName = "employeeIncentiveLeave"

    state = {
        currentModalStatus: false,
        currentIndex: null,
        currentData: {},
        currentDataStatus: "unload",
        filters: {
            start_time: null,
            end_time: null
        },
        data: [],
        dataStatus: "unload",
    }

    actions = {
        selectAction: EmployeeIncentiveLeaveService.select,
        createAction: EmployeeIncentiveLeaveService.create,
        updateAction: EmployeeIncentiveLeaveService.update,
        deleteAction: EmployeeIncentiveLeaveService.delete,
        //exportAction: OvertimeApprovalService.exportOvertimeApproval
    }

    headerColumn = [{
        title: "新增",
        icon: "plus-circle-o",
        access: "c_value",
        click:  () =>{this.createData()}
    },{
        title: "删除",
        access: "d_value",
        icon: "delete",
        click: () =>{this.publicDelete()}
    },
        //  {
        // 	title: "导出",
        // 	access: "export_value",
        // 	icon: "cloud-download-o",
        // 	click: this.publicExport
        // },
    ]

    filterColumn = [{
        type: "person",
        label: "请输入工号或姓名"
    },

    {
        type: "department"
    }, {
        type: "date",
        label: "结束时间",
        key: "search_end_time",
    }, {
        type: "date",
        label: "开始时间",
        key: "search_start_time",
    }
    ]

    tableColumn = [{
        title: '工号',
        dataIndex: 'job_number',
        key: 'job_number',
        className: 'table-global-head-small'
    }, {
        title: '中文名',
        dataIndex: 'real_name',
        key: 'real_name',
        className: 'table-global-head-small'
    }, {
        title: '英文名',
        dataIndex: 'english_name',
        key: 'english_name',
        className: 'table-global-head-small'
    }, {
        title: '部门名称',
        dataIndex: 'department_name',
        key: 'department_name',
        className: 'table-global-head-small'
    }, {
        title: "有效期",
        dataIndex: 'period_validity',
        key: 'period_validity',
        className: 'table-global-head-small'
    }, {
        title: '总天数',
        dataIndex: 'all_days',
        key: 'all_days',
        className: 'table-global-head-short'
    }, {
        title: '剩余天数',
        dataIndex: 'can_use_days',
        key: 'can_use_days',
        className: 'table-global-head-short'
    }, {
        title: "备注",
        dataIndex: 'remark',
        key: 'remark',
        className: 'table-global-head'
    }, {
        title: '操作',
        dataIndex: 'actions',
        key: 'actions',
        className: 'table-global-head-small',
        render: (text, record, index) => (
            <DynamicButton column={this.buttonColumn(text, record, index)}
                module={this.childModuleName}
                access={this.props.access} />
        )
    }
    ]
    buttonColumn = (text, record, index) => [{
        size: "small",
        type: "default",
        icon: "edit",
        title: "修改",
        access: "u_value",
        click: this.updateData.bind(this, record, index)
    }
    ]
    formColumn =()=> [{
        label: "员工姓名",
        key: "employee_id",
        valueKey: "real_name",
        type: "person",
        span: 24,
        valueWidth: "300px",
        valueWidthSelect: "276px",
        rules: {
            disabled: null !== this.state.currentIndex
        },
       
    }, 
    {
        label: "奖励天数",
        key: "all_days",
        type: "number",
        span: 24,
        valueWidth: "300px",
    }, 
    {
        label: "开始日期",
        key: "start_date",
        valueKey:"start_date_str",
        type: "date",
        span: 24,
        valueWidth: "300px",
    }, 
    {
        label: "结束日期",
        key: "end_date",
        valueKey:"end_date_str",
        type: "date",
        span: 24,
        valueWidth: "300px",
    }, 
    {
        label: "备注",
        key: "remark",
        type: "textarea",
        span: 24,
        valueWidth: "300px",
        required:false
    }, 
    ]
    createData = () => this.setState({
		currentData: {},
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: null
	})
    updateData = (record, index) => this.setState({
		currentData: this.dataSource().data.Data[index],
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: index
	})
    publicSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				Object.keys(values).map(item=>{
					console.log(typeof values[item])
				})
				console.log(values)
				const currentData = {
					...this.state.currentData,
                    ...values,
                    start_date:values.start_date?values.start_date.format('YYYY-MM-DD'):null,
                    end_date:values.end_date?values.end_date.format('YYYY-MM-DD'):null,
				}
				const callee = null === this.state.currentIndex ?
					this.publicCreate : this.publicUpdate;
				callee(currentData);
			}
		})
	}

    customComponentWillMount() {
        this.props.fetchDepartmentsList()
    }


    render() {
        return (
            <div className="app-module-item">
                <div className="app-module-header">
                    <DynamicButton column={this.headerColumn}
                        module={"AnnouncementList"}
                        access={this.props.access} />
                </div>
                <div className="app-module-header">
                    <DynamicFilter column={this.filterColumn}
                        departmentsList={this.props.departmentStructure.departmentsList}
                        value={this.dataSource().filters}
                        setFilter={this.publicChange} />
                </div>
                <Modal width="800px"
                maskClosable={false}
                    visible={this.state.currentModalStatus}
                    title={null === this.state.currentIndex?"新增奖励假":"修改奖励假"}
                    destroyOnClose={true}
                    onCancel={this.toggleCurrentModal}
                    onOk={this.publicSubmit} >
                    <DynamicForm column={this.formColumn}
                        form={this.props.form}
                        selectEmployee={this.props.fetchEmployeesList}
                        employees={this.props.employeeManagement.employeeList}
                        loadStatus={this.state.currentDataStatus}
                        dataSource={this.state.currentData} />
                </Modal>
                <div>
                    <DynamicTable column={this.tableColumn}
                        dataStatus={this.dataSource().dataStatus}
                        dataSource={this.dataSource().data.Data}
                        pagination={{
                            total: this.dataSource().data.Total,
                            pageSize: this.dataSource().data.PageSize,
                            current: this.dataSource().filters.page
                        }}
                        rowSelection={this.rowSelection}
                        setPageFilter={this.publicChange} />
                </div>
            </div>
        )
    }
}

EmployeeIncentiveLeave = Form.create()(EmployeeIncentiveLeave);

const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure,
        employeeManagement: state.employeeManagement,
    }
}

const mapDispatchToProps = {
    fetchDepartmentsList,
    fetchEmployeesList,
}

EmployeeIncentiveLeave = connect(mapStateToProps, mapDispatchToProps)(EmployeeIncentiveLeave);

export default LayoutWrapper(EmployeeIncentiveLeave);


// WEBPACK FOOTER //
// ./src/routes/Attendance/employee-incentive-leave.js